import { SCENE_INTERACTION } from "../../constants/scene";
import { SOCKET_EVENTS } from "../../socket/Events";
import {
  getAllUsers,
  getOrganisedUsers,
  organiseUsersByLocation,
} from "../../socket/userUtil";
import FoldableList from "../Basic/FoldableList";
import SwitchButtonComponent from "../Basic/SwitchButtonComponent";
import { UserListPanel } from "../Chat/UserListTabs/UserList-UI";
import { ICON } from "../Icons/Icons";
import { SCENE_EVENTS } from "../MVC/Model";
import {
  ThreeDotsInviteTourItems,
  ThreeDotsOnlineFriendsItems,
  ThreeDotsRoomItems,
  ThreeDotsSceneItems,
  ThreeDotsPodiumItems,
  ThreeDotsTourGuestsItems,
  ThreeDotsTourItems,
} from "./Peoples-UI";
import { WEBRTC_EVENTS } from "../../constants/webrtc";
import {
  tourExists,
} from "../../socket/socketHelper";
import { tourID } from "../../setScene";
import { areInSameSceneId, getSceneId, getSceneNameFromId } from "../MVC/dataHelpers";
import { CHAT_EVENTS } from "../../constants/chat";
import { FEATURE_NAMES } from "../MVC/rolesHelper";
import { GAME_EVENTS } from "../../constants/game";
import { GLOBAL_EVENTS } from "../../constants/global";
import { AMPLITUDE_EVENTS, trackAnalytics } from "../Tracking/baglessAnalytics";

export default class PeoplesList {
  constructor({ model }) {
    this.wrapper = $(UserListPanel());
    this.model = model;
    this.socket = this.model.socket;
    this.currentUserId = this.model.socket.getUserData().userId;

    this.closeButton = this.wrapper.find(".icon-close");
    this.closeButton.on("click", () => {
      this.close();
    });

    $(document).on("click", '#people-list-navbar-button', () => {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    });
    this.setPeopleIconCount(0);

    this.switchButtonWrapper = this.wrapper.find(".switch-button-wrapper");
    this.sceneContainer = this.wrapper.find(".scene-container");
    this.roomContainer = this.wrapper.find(".room-container");
    this.friendsContainer = this.wrapper.find(".friends-container");

    this.tourContainer = this.wrapper.find(".tour-container");
    this.inviteTourContainer = this.wrapper.find(".invite-to-tour-container");
    this.pendingInvitationContainer = this.wrapper.find(
      ".pending-invitation-container"
    );

    this.sceneTab = this.wrapper.find("#user-list-scene");
    this.friendsTab = this.wrapper.find("#user-list-friends");
    this.friendsTab.hide();

    this.participantTab = this.wrapper.find("#user-list-participants");
    this.participantTab.hide();

    $(document.body).append(this.wrapper);
    this.initListeners();
    this.initSwitchButtonComponent();
    this.initScenePeopleFoldable();
    this.initRoomPeopleFoldable();
    this.initFriendsPeopleFoldable();
    this.initPodiumPeopleFoldable();
    this.initInviteToTourPeopleFoldable();
    this.initPendingInvitationPeopleFoldable();
    this.close();
  }

  get peopleIcon() {
    return $("#people-list-navbar-button");
  }

  initListeners() {
    //socket
    const socketEvents = [
      SOCKET_EVENTS.USER_DATA_CHANGED,
      SOCKET_EVENTS.TOUR_USER_CHANGED_SCREEN_SHARE_SEAT,
      SOCKET_EVENTS.ONLINE_FRIENDS_LOADED,
    ];
    socketEvents.forEach((event) => {
      this.socket.addEventListener(event, () => {
        if (this.opened) {
          this.roomUsersUpdate();
          this.sceneUsersUpdate();
          this.tourUpdateListeners();
          this.updateUserActivity();
          this.updateInvitedPeople();
        }
        this.updatePeopleIconCount();
      });
    });
    this.model.addEventListener(GLOBAL_EVENTS.FRIENDS_LOADED, () => {
      this.updateUIAfterFriendsSet();
    });
    this.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, () => {
      this.updatePeopleIconCount();
      this.updateSceneNamesInLists();
    });
    this.model.socket.addEventListener(SOCKET_EVENTS.USER_JOINED_SCENE, () => {
      this.updateSceneNamesInLists();
    });
    this.model.addEventListener(SOCKET_EVENTS.SOCKET_CONNECT_SUCCESS, (e) => {
      $(".world-bottom-nav__area__people__warning-icon").hide();
    });
    this.socket.addEventListener(SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, (e) => {
      this.close();
    });
    this.model.addEventListener(SOCKET_EVENTS.DISCONNECT, () => {
      this.close();
    });
    this.model.addEventListener(SCENE_EVENTS.SHOW_CHESS_MENU, (e) => {
      this.scenePeople.container.find(".menu-item[data-lang='invite-to-chess-game-text']").addClass("disabled");
      this.roomPeople.container.find(".menu-item[data-lang='invite-to-chess-game-text']").addClass("disabled");
    });
    this.model.addEventListener(SCENE_EVENTS.HIDE_CHESS_MENU, (e) => {
      this.scenePeople.container.find(".menu-item[data-lang='invite-to-chess-game-text']").removeClass("disabled");
      this.roomPeople.container.find(".menu-item[data-lang='invite-to-chess-game-text']").removeClass("disabled");
    });


    //closeEvents
    const closeEvents = [
      SCENE_INTERACTION.CHAT_PANEL_OPENED,
      SCENE_EVENTS.NAVBAR_ITEM_CLICKED,
      SCENE_EVENTS.FOLDABLE_DIALOG_OPENED,
      SCENE_INTERACTION.PEOPLE_INFO_OPENED,
      CHAT_EVENTS.JUST_CLOSE_CHAT_UI,
    ]
    closeEvents.forEach((event) => {
      this.model.addEventListener(event, () => {
        this.close();
      });
    });


    //model
    const modelEvents = [
      SCENE_EVENTS.SCENE_DATA_RECIEVED,
      SCENE_EVENTS.TOUR_MODE_STARTED,
      SCENE_EVENTS.TOUR_MODE_ENDED,
      SCENE_EVENTS.GUIDED_MODE_START,
      SCENE_EVENTS.GUIDED_MODE_STOP,
      SCENE_EVENTS.ON_FRIENDS_SET,
      SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED,
      SCENE_INTERACTION.USER_FRIEND_ADDED,
      SCENE_INTERACTION.USER_FRIEND_REMOVED,
      SCENE_EVENTS.HIDE_CHESS_MENU,
    ];
    modelEvents.forEach((event) => {
      this.model.addEventListener(event, () => {
        if (this.opened) {
          this.roomUsersUpdate();
          this.sceneUsersUpdate();
          this.tourUpdateListeners();
          this.handleUIScreen(true);
          this.updateUserActivity();
          this.updateInvitedPeople();
        }
        this.updatePeopleIconCount();
      });
    });
    const gameEvents = [
      GAME_EVENTS.GET_INITIAL_GAME_DATA,
      GAME_EVENTS.JOIN_LOBBY,
      GAME_EVENTS.NEW_VISITOR,
      GAME_EVENTS.NEW_PLAYER,
      GAME_EVENTS.GAME_START,
      GAME_EVENTS.RESTART_GAME,
      GAME_EVENTS.VISITOR_OR_PLAYER_LEFT,
      GAME_EVENTS.UPDATE_GAME_DATA,
    ];

    this.model.socket.addEventListener(SOCKET_EVENTS.GAMING_DATA, (e) => {
      if (this.opened) {
        this.updateUserActivity();
      }
    });

    this.model.addEventListener(SCENE_EVENTS.GAMING_DATA_PROCESSED, (e) => {
      if (this.opened) {
        this.updateUserActivity();
      }
    });


    this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, (e) => {
      this.updateUI(e.data.userId);
      this.updatePeopleIconCount();
    });
    this.model.addEventListener(GLOBAL_EVENTS.MOOD_CHANGED, (e) => {
      this.updateUI(e.data.senderId);
    });
    this.model.addEventListener(SCENE_EVENTS.ON_FRIENDS_SET, (e) => {
      this.friendsUsersUpdate();
      this.updatePeopleIconCount();
      this.updateSceneNamesInLists();
      this.updateUIAfterFriendsSet();
    });
    this.model.addEventListener(SCENE_INTERACTION.USER_FRIEND_ADDED, (e) => {
      this.onFriendAdded({ id: e.data.userId });
      this.updatePeopleIconCount();
    });
    this.model.addEventListener(SCENE_INTERACTION.USER_FRIEND_REMOVED, (e) => {
      this.onFriendRemoved({ id: e.data.userId });
    });
    this.model.addEventListener(
      SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA,
      (e) => {
        if (this.opened) {
          this.tourUpdateListeners();
          this.friendsUsersUpdate();
          this.handleUIScreen(true);
          this.updateUserActivity();
          this.updateInvitedPeople();
        }
        this.updatePeopleIconCount();
      }
    );

    this.model.addEventListener(SCENE_EVENTS.FOLDABLE_DIALOG_BACK, () => {
      this.open();
    });

    this.handleUIScreen();
    $(window).on("resize", () => {
      this.handleUIScreen();
    });
  }

  handleUIScreen() {
    this.switchButtonComponentUpdate();
  }

  tourUpdateListeners() {
    this.resolveInvitationGhosts();
    this.switchButtonComponentUpdate();
    this.tourPodiumUpdate();
    this.inviteToTourUpdate();
    this.pendingInvitationUpdate();
    this.renderInvitationGhosts();
    this.applyInvitationLocks();
    this.updatePeopleIconCount();
  }

  invitationGhostKind(userId) {
    return this.model.pendingTourInvitations?.get(String(userId)) || null;
  }

  resolveInvitationGhosts() {
    const pending = this.model.pendingTourInvitations;
    if (!pending || !pending.size) {
      return;
    }
    const tour = this.model.iAmInTour();
    if (!tour) {
      [this.podiumPeople, this.inviteToTourPeople].forEach((list) => {
        if (!list) {
          return;
        }
        [...list.itemIds].forEach((userId) => {
          const row = list.participantsList.children(`[data-participant-id="${userId}"]`);
          if (row.hasClass("participant-row--ghost")) {
            list.removeItem(userId);
          }
        });
      });
      [...pending.keys()].forEach((userId) => {
        this.model.clearPendingTourInvitation(userId, null, { notify: false });
      });
      return;
    }
    const online = this.model.socket.getUsersObject() || {};
    const podiumIds = new Set((tour.podiumUsers || []).map(String));
    const streamIds = new Set(Object.keys(tour.streams || {}));
    const guestIds = new Set((tour.guests || []).map(String));
    const tourUserIds = new Set((tour.users || []).map(String));
    [...pending.entries()].forEach(([userId, kind]) => {
      const user = online[userId];
      if (!user) {
        this.model.clearPendingTourInvitation(userId, kind, { notify: false });
        return;
      }
      const socketId = String(user.socketId);
      const joinedPodium = kind === "podium" && (podiumIds.has(socketId) || streamIds.has(socketId) || guestIds.has(socketId));
      const joinedTour = kind === "guests" && tourUserIds.has(socketId);
      if (joinedPodium || joinedTour) {
        this.model.clearPendingTourInvitation(userId, kind, { notify: false });
      }
    });
  }

  renderInvitationGhosts() {
    const pending = this.model.pendingTourInvitations;
    const lists = {
      podium: this.podiumPeople,
      guests: this.inviteToTourPeople,
    };
    if (!pending) {
      return;
    }
    const online = this.model.socket.getUsersObject() || {};
    const waitingLabel = $trans("waiting-for-response-text");
    pending.forEach((kind, userId) => {
      const list = lists[kind];
      const user = online[userId];
      if (!list || !user) {
        return;
      }
      list.renderGhostItem({
        id: user.userId,
        name: `${user.userName} ${waitingLabel}`,
        userAvatarUrl: user.userAvatarUrl || user.avatar_image_url,
      });
    });
  }

  applyInvitationLocks() {
    const lists = [this.podiumPeople, this.inviteToTourPeople, this.pendingInvitationPeople];
    lists.forEach((list) => {
      if (!list) {
        return;
      }
      list.participantsList.find(".participant-row").each((_, element) => {
        const row = $(element);
        if (row.hasClass("participant-row--ghost")) {
          return;
        }
        const userId = row.attr("data-participant-id");
        const locked = !!this.invitationGhostKind(userId);
        // A declined invite removes the ghost without a dragend, which used to
        // leave the source row on the drag opacity.
        row.removeClass("is-dragging");
        row.toggleClass("is-invitation-locked", locked);
        row.find(".icon-wrapper").each((_, icon) => {
          const wrapper = $(icon);
          wrapper.toggleClass("icon-wrapper--message", wrapper.find(".icon-message").length > 0);
        });
        if (locked) {
          row.find(".participant-row__drag").remove();
        }
      });
    });
  }

  close() {
    const wasOpen = this.opened;
    this.opened = false;
    this.wrapper.hide();
    this.peopleIcon.removeClass("selected");
    this.model.dispatchEvent({ type: SCENE_INTERACTION.PEOPLE_PANEL_CLOSED });
    if (wasOpen) {
      trackAnalytics(this.model, AMPLITUDE_EVENTS.CLOSED_PEOPLE, { t: Date.now() });
    }
  }

  open() {
    this.tourUpdateListeners();
    this.sceneUsersUpdate();
    this.roomUsersUpdate();
    this.updateInvitedPeople();
    this.updatePeopleIconCount();
    this.updateSceneNamesInLists();
    this.updateUserActivity();
    const wasOpen = this.opened;
    this.opened = true;
    this.wrapper.show();
    this.peopleIcon.addClass("selected");
    this.model.dispatchEvent({ type: SCENE_INTERACTION.PEOPLE_PANEL_OPENED });
    if (!wasOpen) {
      trackAnalytics(this.model, AMPLITUDE_EVENTS.OPENED_PEOPLE, { t: Date.now() });
    }
    if (this.model.isUserPlayingChess(this.model.config.userId)) {
      this.scenePeople && this?.scenePeople?.container?.find(".menu-item[data-lang='invite-to-chess-game-text']").removeClass("disabled");
      this.scenePeople && this?.roomPeople?.container?.find(".menu-item[data-lang='invite-to-chess-game-text']").removeClass("disabled");
    } else {
      this.scenePeople && this?.scenePeople?.container?.find(".menu-item[data-lang='invite-to-chess-game-text']").addClass("disabled");
      this.scenePeople && this?.roomPeople?.container?.find(".menu-item[data-lang='invite-to-chess-game-text']").addClass("disabled");
    }
  }

  initSwitchButtonComponent() {
    const buttonsConfig = [
      {
        name: "visitors",
        label: "This Space",
        lang: "this-space",
        selected: true,
      },
      { name: "participants", label: "Participants", lang: "en-participants" },
      {
        name: "friends",
        label: "Friends",
        lang: "en-friends",
        disabled: this.model.config.isGuest,
      },
    ];

    this.switchButton = new SwitchButtonComponent(
      this.switchButtonWrapper[0],
      buttonsConfig,
      async (index, buttonConfig) => {
        // prevent if not allowed
        if (buttonConfig.name === "friends" && !await this.model.validatePlanFeature(FEATURE_NAMES.BUDDY_LIST)) {
          return;
        }

        this.sceneTab.hide();
        this.friendsTab.hide();
        this.participantTab.hide();
        if (buttonConfig.name === "visitors") {
          this.sceneTab.show();
        }
        if (buttonConfig.name === "participants") {
          this.participantTab.show();
        }
        if (buttonConfig.name === "friends") {
          this.friendsTab.show();
        }
      }
    );

    this.switchButtonComponentUpdate();
  }

  switchButtonComponentUpdate() {
    const tourStarted = this.model.iAmInTour();
    const availableTabs = []
    if (tourStarted) {
      this.switchButtonWrapper.find('[data-name="visitors"]').hide();
      this.switchButtonWrapper.find('[data-name="participants"]').text(tourStarted.name);
      this.switchButtonWrapper.find('[data-name="participants"]').show();
      availableTabs.push("participants")

      if (this.model.canRunTour()) {
        this.pendingInvitationContainer.show();
        const hideTourGuests = this.model.isOneToOneTour(tourStarted);
        this.inviteTourContainer.toggleClass('is-one-to-one-hidden', hideTourGuests);
        if (hideTourGuests) {
          this.inviteTourContainer.hide();
        } else {
          this.inviteTourContainer.show();
        }
      } else {
        this.inviteTourContainer.hide();
        this.pendingInvitationContainer.hide();
      }
    } else {
      this.switchButtonWrapper.find('[data-name="visitors"]').show();
      availableTabs.push("visitors")
      this.switchButtonWrapper.find('[data-name="participants"]').hide();
    }
    if (this.model.config.isGuest || !this.model.friends) {
      this.switchButtonWrapper.find('[data-name="friends"]').hide();
    } else {
      this.switchButtonWrapper.find('[data-name="friends"]').show();
      availableTabs.push("friends")
    }

    const currentTab = this.switchButtonWrapper.find('.switch-button.selected').data('name');
    if (!availableTabs.includes(currentTab) && availableTabs.length > 0) {
      this.switchButtonWrapper.find(`[data-name="${availableTabs[0]}"]`).trigger("click");
    }
  }

  initScenePeopleFoldable() {
    this.scenePeople = new FoldableList({
      model: this.model,
      containerSelector: this.sceneContainer[0],
      participantsConfig: [],
      onParticipantClick: async (participant, e) => {
        if ($(e.target).is("img")) {
          if (participant.id === this.currentUserId) {
            $("#editProfile").trigger("click");
            this.close();
          } else {
            const socketItem = this.model.socket.getUsersObject()[participant.id];
            this.model.showUserInfo({
              data: null,
              userId: participant.id,
              eventOrigin: "nepoznatiFleg",
              socketItem,
            });
            this.close();
          }
        }
        if ($(e.target).hasClass("icon-chess-horse")) {
          if (participant.id === this.currentUserId) {
            return;
          }
          else {
            if (this.model.notAvailableInTourMode() || (this.model.iAmGuide() || this.model.guide)) {
              this.model.alert('error', $trans('error-not-available-intour-mode'));
              return;
            }
            const socketItem = this.model.socket.getUsersObject()[participant.id];
            const hasChessGame = this.model.isUserPlayingChess(participant.id) || this.model.isUserVisitorInChessGame(participant.id) || this.model.isUserInChessRoom(participant.id);
            if (hasChessGame?.chessGame?.gameData?.isLocked) {
              this.model.alert('error', $trans('chess-game-locked'));
              return;
            }
            const mySceneId = this.model.socket.getUsersObject()[this.model.config.userId].currentSceneId;
            if (socketItem.currentSceneId === mySceneId && hasChessGame) {
              this.model.openChessModal(hasChessGame, socketItem.userId);
              this.close();
            }
          }
        }
        console.log("Participant clicked:", participant, e.currentTarget);
      },
      dataLang: "scene-text-chat",
      title: $trans('scene-text-chat'),
      onIconClick: (index, participant, event) =>
        this.handleIconClick(index, participant, event),
    });
  }

  initRoomPeopleFoldable() {
    this.roomPeople = new FoldableList({
      model: this.model,
      containerSelector: this.roomContainer[0],
      participantsConfig: [],
      onParticipantClick: (participant, e) => {
        this.handleParticipantClick(participant, e);
      },
      dataLang: "room-text",
      title: $trans('room-text'),
      onIconClick: (index, participant, event) =>
        this.handleIconClick(index, participant, event),
    });
  }

  initFriendsPeopleFoldable() {
    if (this.model.config.isGuest || !this.model.friends) {
      return;
    }
    const users = this.model.socket.getUsersObject();
    const { online, offline } = this.model.friends;
    this.friendsPeople = new FoldableList({
      model: this.model,
      containerSelector: this.friendsContainer[0],
      participantsConfig: [...online, ...offline].map((friend) => {
        friend.currentUserMood = users[friend.id]?.currentUserMood;
        friend.showCurrentMood = true;
        friend.userActivity = true;
        return friend;
      }),
      onParticipantClick: async (participant, e) => {
        if ($(e.target).hasClass("participant-scene-name")) {
          if ($(e.target).hasClass("is-jump-disabled") || this.isFriendLocationJumpBlocked(participant.id)) {
            return;
          }
          if (!await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_JUMP_TO_USER)) {
            return;
          }
          if (participant.online) {
            if (!participant.worldId) {
              this.model.alert("Error reading users data");
              return;
            }
            if (this.model.chessGameMode) {
              this.model.confirm($trans('exit-game-confirm'), () => {
                this.model.worldFetcher.getWorldIdSec(participant.worldId, (data) => {
                  const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
                  if (!user) {
                    this.model.alert("Error reading users data");
                    return;
                  }
                  if (user?.worldId !== this.model.socket.getUserData().worldId) {
                    const callback = () => {
                      window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${user.worldId}&security=${data.h}&loc=${user.currentSceneId}`;
                    }
                    this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback() } } })
                    this.close();
                  } else {
                    const sceneId = getSceneId(user, this.model.sceneData.scenes);
                    this.model.dispatchEvent({
                      type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
                        sceneId: sceneId
                      }
                    });
                    this.close();
                  }
                }, (error) => {
                  console.log("error", error);
                })
              }, {
                title: $trans('leave-game-text'),
              })
            }
            else {
              this.model.worldFetcher.getWorldIdSec(participant.worldId, (data) => {
                const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
                if (!user) {
                  this.model.alert("Error reading users data");
                  return;
                }
                if (user?.worldId !== this.model.socket.getUserData().worldId) {
                  const callback = () => {
                    window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${user.worldId}&security=${data.h}&loc=${user.currentSceneId}`;
                  }
                  this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback() } } })
                  this.close();
                } else {
                  const sceneId = getSceneId(user, this.model.sceneData.scenes);
                  this.model.dispatchEvent({
                    type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
                      sceneId: sceneId
                    }
                  });
                }
              }, (error) => {
                console.log("error", error);
              })
            }
            return;
          }
        }
      },
      dataLang: "friends-text",
      title: $trans('friends-text'),
      onIconClick: (index, participant, event) => {
        this.onClickIconPersonAction(event, participant);
        if ($(event.currentTarget).find('svg').hasClass("icon-message")) {
          if (participant.online) {
            const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
            if (user) {
              this.model.createAndOpenChat(user);
            } else {
              this.model.info('info', $trans('user-not-online-error-text'));
              return;
            }
            this.close();
          } else {
            this.model.dispatchEvent({
              type: SCENE_EVENTS.CREATE_OFFLINE_CHAT,
              data: participant,
            });
            this.close();
          }
        }
        if ($(event.currentTarget).find('svg').hasClass("go-to-space")) {
          if ($(event.currentTarget).hasClass("disabled") || this.isFriendLocationJumpBlocked(participant.id)) {
            return;
          }
          if (participant.online) {
            if (this.model.chessGameMode) {
              this.model.confirm($trans('exit-game-confirm'), () => {
                this.model.worldFetcher.getWorldIdSec(participant.worldId, (data) => {
                  const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
                  if (!user) {
                    this.model.alert("Error reading users data");
                    return;
                  }
                  if (user?.worldId !== this.model.socket.getUserData().worldId) {
                    const callback = () => {
                      window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${user.worldId}&security=${data.h}&loc=${user.currentSceneId}`;
                    }
                    this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback() } } })
                    this.close();
                  } else {
                    const sceneId = getSceneId(user, this.model.sceneData.scenes);
                    this.model.dispatchEvent({
                      type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
                        sceneId: sceneId
                      }
                    });
                    this.close();
                  }
                }, (error) => {
                  console.log("error", error);
                })
              }, {
                title: $trans('leave-game-text'),
              })
            }
            else {
              this.model.worldFetcher.getWorldIdSec(participant.worldId, (data) => {
                const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
                if (!user) {
                  this.model.alert("Error reading users data");
                  return;
                }
                if (user?.worldId !== this.model.socket.getUserData().worldId) {
                  const callback = () => {
                    window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${user.worldId}&security=${data.h}&loc=${user.currentSceneId}`;
                  }
                  this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback() } } })
                  this.close();
                } else {
                  const sceneId = getSceneId(user, this.model.sceneData.scenes);
                  this.model.dispatchEvent({
                    type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
                      sceneId: sceneId
                    }
                  });
                  this.close();
                }
              }, (error) => {
                console.log("error", error);
              })
            }
            return;
          }
        }
      },
      enableSearch: true,
      onSearch: (search) => this.friendsUsersUpdate(search),
    });
  }

  initPodiumPeopleFoldable() {
    this.podiumPeople = new FoldableList({
      model: this.model,
      containerSelector: this.tourContainer[0],
      participantsConfig: [],
      onParticipantClick: (participant, e) =>
        this.handleParticipantClick(participant, e),
      dataLang: "podium-text",
      title: $trans('podium-text'),
      onIconClick: (index, participant, event) =>
        this.handleIconClick(index, participant, event),
      dragListId: "podium",
      canDragParticipant: (participant) => this.canDragTourParticipant(participant),
      onParticipantDrop: (payload) => this.onTourParticipantDrop(payload),
    });
  }

  initInviteToTourPeopleFoldable() {
    this.inviteToTourPeople = new FoldableList({
      model: this.model,
      containerSelector: this.inviteTourContainer[0],
      participantsConfig: [],
      onParticipantClick: (participant, e) => {
        const user = this.model.socket.getUsersObject()[participant.id];
        const isInTour = this.model.isUserInTour(user.userId);
        const iAmInTour = this.model.iAmInTour();
        let sameTour = false;
        if (isInTour && iAmInTour) {
          sameTour = isInTour.id === iAmInTour.id;
        }
        if (!this.model.iAmGuide()) {
          return;
        }
        if (isInTour && !sameTour) {
          this.model.alert("error", $trans('user-in-tour-error-text'));
          return;
        }
        if (user) {
          this.model.info('info', $trans('invite-to-podium-text-user').replace("{user}", user.userName));
          this.model.inviteUserToPodium(user);
        }
      },
      dataLang: "invite-to-podium-text",
      title: $trans('invite-to-podium-text'),
      onIconClick: (index, participant, event) =>
        this.handleIconClick(index, participant, event),
      dragListId: "guests",
      canDragParticipant: (participant) => this.canDragTourParticipant(participant),
      onParticipantDrop: (payload) => this.onTourParticipantDrop(payload),
    });
  }

  initPendingInvitationPeopleFoldable() {
    this.pendingInvitationPeople = new FoldableList({
      model: this.model,
      containerSelector: this.pendingInvitationContainer[0],
      participantsConfig: [],
      onParticipantClick: (participant, e) => {
        if (!this.model.iAmGuide()) {
          return;
        }
        const socketItem = this.model.socket.getUsersObject()[participant.id];
        const instance = this.pendingInvitationPeople.userActivityInstances.get(participant.id)
        if (!instance) {
          return;
        }
        const activeState = instance.getState().activeState;
        if (this.model.isUserInTour(socketItem) || activeState === "tour") {
          this.model.alert("error", $trans('user-in-tour-error-text'));
          return;
        }
        if (activeState === "meeting") {
          this.model.alert("error", $trans('user-in-meeting-error-text'));
          return;
        }
        if (this.model.isOneToOneTour(this.model.iAmInTour())) {
          this.model.inviteUserToPodium(socketItem);
          return;
        }
        this.model.removeUserFromInvitationTourList(participant.id);
        this.model.inviteUserToTour(socketItem);
      },
      dataLang: "pending-invitation-text",
      title: $trans('pending-invitation-text'),
      onIconClick: (index, participant, event) =>
        this.handleIconClick(index, participant, event),
      dragListId: "not-in-tour",
      canDragParticipant: (participant) => this.canDragTourParticipant(participant),
      onParticipantDrop: (payload) => this.onTourParticipantDrop(payload),
    });
  }

  rowUserOnPodium(tour, socketItem) {
    if (!tour || !socketItem || this.model.iAmGuide()) {
      return false;
    }
    if (String(socketItem.userId) !== String(this.currentUserId)) {
      return false;
    }
    const socketId = socketItem.socketId;
    if ((tour.podiumUsers || []).some((id) => String(id) === String(socketId))) {
      return true;
    }
    if ((tour.guests || []).some((id) => String(id) === String(socketId))) {
      return true;
    }
    if (tour.streams && (tour.streams[socketId] || tour.streams[String(socketId)])) {
      return true;
    }
    return !!this.model.isTourGuest;
  }

  selfTourAction({ title, danger, onClick }) {
    const button = $(`<div class="icon-wrapper participant-row__self-action${danger ? " icon-wrapper--danger" : ""}">${ICON.EXIT}</div>`);
    button.attr("title", title);
    button.on("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    });
    return button;
  }

  attachSelfTourActions(row, { podium }) {
    row.find(".participant-row__self-action").remove();
    if (!row.length || row.hasClass("participant-row--ghost")) {
      return;
    }
    if (String(row.attr("data-participant-id")) !== String(this.currentUserId) || this.model.iAmGuide()) {
      return;
    }
    const wrapper = row.find(".icons-wrapper");
    if (!wrapper.length) {
      return;
    }

    const actions = [];
    if (podium) {
      actions.push(this.selfTourAction({
        title: $trans("exit-podium", {}, "Exit podium"),
        onClick: () => {
          this.model.confirm($trans("exit-podium-confirm", {}, "Leave the podium? You will stay in the tour as a guest."), () => {
            this.model.socket.socketTour.leavePodium();
          }, {
            header: true,
            title: $trans("exit-podium", {}, "Exit podium"),
            confirmBtnTxt: $trans("exit-podium-confirm-btn", {}, "Exit podium"),
          });
        },
      }));
    }
    actions.push(this.selfTourAction({
      title: $trans("exit-tour", {}, "Exit tour"),
      danger: true,
      onClick: () => {
        if (podium) {
          this.model.confirm(
            $trans("exit-tour-choice", {}, "Do you want to guest list or exit Tour"),
            () => {
              this.model.onTourEnded();
            },
            {
              header: true,
              title: $trans("exit-tour", {}, "Exit tour"),
              confirmBtnTxt: $trans("exit-tour-choice-exit", {}, "Exit Tour"),
              cancelBtnTxt: $trans("exit-tour-choice-guest", {}, "Guest list"),
              xBtn: false,
              dimmerClose: false,
            },
            () => {
              this.model.socket.socketTour.leavePodium();
            }
          );
          return;
        }
        this.model.confirm($trans("exit-tour-confirm"), () => {
          this.model.onTourEnded();
        }, {
          header: true,
          title: $trans("exit-tour", {}, "Exit tour"),
          confirmBtnTxt: $trans("exit-tour-confirm-btn"),
        });
      },
    }));
    actions.reverse().forEach((action) => wrapper.prepend(action));
  }

  canDragTourParticipant(participant) {
    if (!this.model.iAmGuide() || String(participant.id) === String(this.currentUserId)) {
      return false;
    }
    return !this.invitationGhostKind(participant.id);
  }

  onTourParticipantDrop({ participantId, fromListId, toListId }) {
    if (!this.model.iAmGuide() || !participantId || fromListId === toListId) {
      return;
    }
    const socketItem = this.model.socket.getUsersObject()?.[participantId];
    if (!socketItem || String(socketItem.userId) === String(this.currentUserId)) {
      return;
    }

    if (toListId === "not-in-tour") {
      this.model.removeUserFromTour(socketItem);
      return;
    }

    if (toListId === "podium") {
      const isInTour = this.model.isUserInTour(socketItem.userId);
      const myTour = this.model.iAmInTour();
      if (isInTour && myTour && isInTour.id !== myTour.id) {
        this.model.alert("error", $trans("user-in-tour-error-text"));
        return;
      }
      this.model.inviteUserToPodium(socketItem);
      return;
    }

    if (toListId === "guests") {
      if (this.model.isOneToOneTour(this.model.iAmInTour())) {
        return;
      }
      // Already on the podium: leaving it puts them in Tour Guests.
      if (fromListId === "podium") {
        this.model.removeUserFromPodium(socketItem);
        return;
      }
      const instance = this.pendingInvitationPeople.userActivityInstances.get(participantId);
      const activeState = instance && instance.getState && instance.getState().activeState;
      if (this.model.isUserInTour(socketItem.userId) || activeState === "tour") {
        this.model.alert("error", $trans("user-in-tour-error-text"));
        return;
      }
      if (activeState === "meeting") {
        this.model.alert("error", $trans("user-in-meeting-error-text"));
        return;
      }
      this.model.removeUserFromInvitationTourList(participantId);
      this.model.inviteUserToTour(socketItem);
    }
  }

  async handleParticipantClick(participant, e) {
    const user = this.model.socket.getUsersObject()[participant.id];
    if ($(e.target).is("img")) {
      if (participant.id === this.currentUserId) {
        $("#mediaSettings").trigger("click");
        this.close();
      } else {
        this.model.showUserInfo({
          data: null,
          userId: participant.id,
          eventOrigin: "nepoznatiFleg",
          socketItem: user,
        });
        this.close();
      }
    }
    if ($(e.target).hasClass("participant-scene-name")) {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_JUMP_TO_USER)) {
        return;
      }

      this.close();
      this.model.dispatchEvent({
        type: SCENE_INTERACTION.JUMP_TO_SCENE,
        data: {
          sceneId: user.currentSceneId,
        },
      });
    } else if ($(e.target).hasClass("participant-row")) {
    }
  }

  handleIconClick(index, participant, event) {
    this.onClickIconPersonAction(event, participant);
    this.onClickIconMessageAction(event, participant);
    this.handleIconConfigClick(event, participant);
  }

  handleIconConfigClick(event, participant) {
    if (!$(event.currentTarget).find('svg').hasClass("icon-config")) {
      return;
    }
    $("#mediaSettings").trigger("click");
  }

  sceneUsersUpdate() {
    const currentSceneId = this.model.currentScene.id;
    const socketMe = this.model.socket.getUserData();
    socketMe.currentSceneName = this.model.getCurrentSceneName();
    socketMe.currentSceneId = currentSceneId;
    // Organise first. Reading the previous map showed only this user until
    // another event refreshed the list.
    organiseUsersByLocation(this.model.socket.getUsersObject(), socketMe);
    const sceneUsers = [...(getOrganisedUsers()[currentSceneId] || [])];
    sceneUsers.unshift(socketMe);

    this.scenePeople.itemIds.forEach((userId) => {
      if (!sceneUsers.some((user) => user.userId === userId)) {
        this.scenePeople.removeItem(userId);
      }
    });
    sceneUsers.map((socketItem) => {
      if (this.scenePeople.itemIds.has(socketItem.userId)) {
        return;
      } else {
        this.scenePeople.renderSingleItem({
          name: socketItem.userName,
          id: socketItem.userId,
          worldId: socketItem.worldId,
          isGuest: socketItem.isGuest,
          userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
          icons: [
            // { src: ICON.PERSON },
            // { src: ICON.PERSON_WITH_GREEN_STAR },
            { src: ICON.MESSAGE },
            { src: ICON.THREE_DOTS },
            { src: ICON.CONFIG },
          ],
          userActivity: true,
          onActivityClick: (state, event) => {
            this.onClickActivityClick(state, event, socketItem);
          },
          threeDotsContainer: ThreeDotsSceneItems(),
          threeDotsCallback: (index, participant, event, userActivityInstance) => {
            this.onClickShowUserInfoTextAction(event, participant, socketItem);
            this.onClickRemoveFriendTextAction(event, participant);
            this.onClickAddFriendTextAction(event, participant);
            this.onClickVideoCallTextAction(event, participant);
            this.onClickChatTextAction(event, participant);
            this.onClickPlayChessTextAction(event, participant, userActivityInstance);
            this.onClickStartOneOnOneTourAction(event, socketItem);
          },
          customRender: (row) => {
            this.handleCustomRowActions(row, socketItem);
            row.find(".participant-name-and-scene-holder").remove();
          },
        });
      }
    });
    this.scenePeople.renderParticipants();
  }

  roomUsersUpdate() {
    const socketMe = this.model.socket.getUserData();
    organiseUsersByLocation(this.model.socket.getUsersObject(), socketMe);
    const sceneUsers = [...getAllUsers()];
    if (!sceneUsers.some((user) => user.userId === socketMe.userId)) {
      sceneUsers.push(socketMe);
    }
    this.roomPeople.itemIds.forEach((userId) => {
      if (!sceneUsers.some((user) => user.userId === userId)) {
        this.roomPeople.removeItem(userId);
      }
    });
    sceneUsers.map((socketItem) => {
      if ((this.roomPeople.itemIds.has(socketItem.userId) || socketItem.userId === this.model.config.userId)) {
        return;
      } else {
        this.roomPeople.renderSingleItem({
          name: socketItem.userName,
          id: socketItem.userId,
          worldId: socketItem.worldId,
          isGuest: socketItem.isGuest,
          userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
          icons: [
            { src: ICON.MESSAGE },
            { src: ICON.THREE_DOTS },
          ],
          userActivity: true,
          onActivityClick: (state, event) => {
            this.onClickActivityClick(state, event, socketItem);
          },
          currentSceneName: areInSameSceneId(socketItem, this.model.socket._currentUserData[this.model.config.userId]) ? '' : getSceneNameFromId(socketItem, this.model),
          threeDotsContainer: ThreeDotsRoomItems(socketItem),
          threeDotsCallback: (index, participant, event, userActivityInstance) => {
            this.onClickJumpToSceneAction(event, participant);
            this.onClickInviteToSceneTextAction(event, participant);
            this.onClickShowUserInfoTextAction(event, participant, socketItem);
            this.onClickRemoveFriendTextAction(event, participant);
            this.onClickAddFriendTextAction(event, participant);
            this.onClickVideoCallTextAction(event, participant);
            this.onClickChatTextAction(event, participant);
            this.onClickPlayChessTextAction(event, participant, userActivityInstance);
            this.onClickStartOneOnOneTourAction(event, socketItem);
          },
          customRender: (row) => {
            this.handleCustomRowActions(row, socketItem);
            row.find(".single-name").remove();
          },
        });
      }
    });
    this.roomPeople.renderParticipants();
  }

  friendsUsersUpdate(search = "") {
    if (!this.friendsPeople) {
      return
    }
    const users = this.model.socket.getUsersObject();
    const { online, offline } = this.model.friends;
    this.friendsPeople.itemIds.forEach((userId) => {
      if (online.some((user) => user.userId === userId)) {
        this.friendsPeople.removeItem(userId);
      }
    });
    this.friendsPeople.itemIds.forEach((userId) => {
      if (offline.some((user) => user.id === userId)) {
        this.friendsPeople.removeItem(userId);
      }
    });

    let onlineUsers = [...online];
    let offlineUsers = [...offline];
    if (search) {
      const lowerSearch = search.toLowerCase();
      onlineUsers = onlineUsers.filter((user) =>
        user.userName.toLowerCase().includes(lowerSearch)
      );
      offlineUsers = offlineUsers.filter((user) =>
        user.username.toLowerCase().includes(lowerSearch)
      );
    }

    onlineUsers.map((socketItem) => {
      if (this.friendsPeople.itemIds.has(socketItem.userId)) {
        return;
      } else {
        this.friendsPeople.renderSingleItem({
          online: true,
          name: socketItem.userName,
          id: socketItem.userId,
          worldId: socketItem.worldId,
          userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
          showCurrentMood: true,
          currentUserMood: users[socketItem.userId]?.currentUserMood,
          icons: [{ src: ICON.MESSAGE }, { src: ICON.GO_TO_SCENE }, { src: ICON.THREE_DOTS }],
          currentSceneName: areInSameSceneId(socketItem, this.model.socket._currentUserData[this.model.config.userId]) ? '' : getSceneNameFromId(socketItem, this.model),
          threeDotsContainer: ThreeDotsOnlineFriendsItems(socketItem),
          userActivity: true,
          onActivityClick: (state, event) => {
            this.onClickActivityClick(state, event, socketItem);
          },
          threeDotsCallback: (index, participant, event) => {
            this.onClickJumpToSceneAction(event, participant);
            this.onClickShowUserInfoTextAction(event, participant, socketItem);
            this.onClickRemoveFriendTextAction(event, participant);
            this.onClickVideoCallTextAction(event, participant);
            this.onClickInviteToSceneTextAction(event, participant);
            this.onClickStartOneOnOneTourAction(event, socketItem);
          },
          customRender: (row) => {
            row.find(".single-name").remove();
            // Since these are friends, we want to show remove friend option and hide add friend
            row.find('[data-lang="add-as-friend-text"]').hide();
            row.find('[data-lang="remove-from-friends-text"]').show();
            row.find(".icon-person").parent().hide();
            row.find(".icon-person-with-star").parent().show();
            this.setFriendLocationJumpEnabled(row, !this.isFriendLocationJumpBlocked(socketItem.userId));
          },
        });
      }
    });
    offlineUsers.map((socketItem) => {
      if (this.friendsPeople.itemIds.has(socketItem.userId)) {
        return;
      } else {
        this.friendsPeople.renderSingleItem({
          online: false,
          name: socketItem.username,
          id: socketItem.id,
          worldId: socketItem.worldId,
          userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
          showCurrentMood: true,
          icons: [{ src: ICON.MESSAGE }, { src: ICON.THREE_DOTS }],
          threeDotsContainer: ThreeDotsTourItems(socketItem, { hideVideoCall: true, hideOneOnOneTour: true }),
          threeDotsCallback: (index, participant, event) => {
            this.onClickShowUserInfoTextAction(event, participant, socketItem);
            this.onClickRemoveFriendTextAction(event, participant);
          },
          customRender: (row) => {
            row.find(".participant-name-and-scene-holder").remove();
            // Since these are friends, we want to show remove friend option and hide add friend
            row.find('[data-lang="add-as-friend-text"]').hide();
            row.find('[data-lang="remove-from-friends-text"]').show();
            row.find('[data-lang="video-call-text"]').hide();
            row.find('[data-lang="start-one-on-one-tour-text"]').hide();
            row.find(".icon-person").parent().hide();
            row.find(".icon-person-with-star").parent().show();
          },
        });
      }
    });
    this.friendsPeople.renderParticipants();
  }

  tourPodiumUpdate() {
    ////podium people
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted) {
      return;
    }
    const allUsers = this.model.getUsers();
    const podiumIds = new Set((tourStarted.podiumUsers || []).map(String));
    const streamingUserObjects = allUsers.filter(user => podiumIds.has(String(user.socketId)));

    [...this.podiumPeople.itemIds].forEach((userId) => {
      const row = this.podiumPeople.participantsList.children(`[data-participant-id="${userId}"]`);
      const isGhost = row.hasClass("participant-row--ghost");
      const onPodium = streamingUserObjects.some((user) => String(user.userId) === String(userId));
      if (isGhost && onPodium) {
        this.model.clearPendingTourInvitation(userId, "podium", { notify: false });
        this.podiumPeople.removeItem(userId);
        return;
      }
      if (isGhost && this.invitationGhostKind(userId) === "podium") {
        return;
      }
      if (isGhost || !onPodium) {
        this.podiumPeople.removeItem(userId);
      }
    });
    streamingUserObjects.map((socketItem) => {
      const existing = this.podiumPeople.participantsList.children(`[data-participant-id="${socketItem.userId}"]`);
      if (existing.hasClass("participant-row--ghost")) {
        this.model.clearPendingTourInvitation(socketItem.userId, "podium", { notify: false });
        this.podiumPeople.removeItem(socketItem.userId);
      }
      if (this.podiumPeople.itemIds.has(socketItem.userId)) {
        this.podiumPeople.ensureDragHandle({ id: socketItem.userId });
        this.attachSelfTourActions(existing, { podium: true });
        return;
      } else {
        this.podiumPeople.renderSingleItem({
          name: socketItem.userName,
          id: socketItem.userId,
          worldId: socketItem.worldId,
          userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
          icons: [
            { src: ICON.MESSAGE },
            { src: ICON.THREE_DOTS },
          ],
          currentSceneName: socketItem.currentSceneName,
          threeDotsContainer: ThreeDotsPodiumItems(socketItem),
          threeDotsCallback: (index, participant, event) => {
            if (!this.model.iAmGuide()) {
              return;
            }
            this.onClickShowUserInfoTextAction(event, participant, socketItem);
            this.onClickRemoveFromPodiumTextAction(event, participant, socketItem);
            this.onClickRemoveFromTourTextAction(event, participant, socketItem);
          },
          customRender: (row) => {
            this.handleCustomRowActions(row, socketItem);
            row.find(".participant-name-and-scene-holder").remove();
            if (!this.model.iAmGuide()) {
              row.find('[data-lang="remove-from-podium-text"]').remove();
              row.find('[data-lang="remove-from-tour-text"]').remove();
            }
            this.attachSelfTourActions(row, { podium: true });
          },
        });
      }
    });
    this.podiumPeople.renderParticipants();
  }

  inviteToTourUpdate() {
    ///people are in the tour waitin to be invited to podium
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted || this.model.isOneToOneTour(tourStarted)) {
      return;
    }
    const allUsers = this.model.socket.getUsers();
    const tourUsers = new Set(tourStarted.users);
    const podiumUsers = new Set(tourStarted.podiumUsers);
    const availableUsers = allUsers.filter(user => {
      if (tourUsers.has(user.socketId) && !podiumUsers.has(user.socketId)) {
        return true;
      }
      return false;
    });


    [...this.inviteToTourPeople.itemIds].forEach((userId) => {
      const row = this.inviteToTourPeople.participantsList.children(`[data-participant-id="${userId}"]`);
      const isGhost = row.hasClass("participant-row--ghost");
      const inGuests = availableUsers.some((user) => String(user.userId) === String(userId));
      if (isGhost && inGuests) {
        this.model.clearPendingTourInvitation(userId, "guests", { notify: false });
        this.inviteToTourPeople.removeItem(userId);
        return;
      }
      if (isGhost && this.invitationGhostKind(userId) === "guests") {
        return;
      }
      if (isGhost || !inGuests) {
        this.inviteToTourPeople.removeItem(userId);
      }
    });

    availableUsers.forEach((socketItem) => {
      if (this.inviteToTourPeople.itemIds.has(socketItem.userId)) {
        this.inviteToTourPeople.ensureDragHandle({ id: socketItem.userId });
        const row = this.inviteToTourPeople.participantsList.children(`[data-participant-id="${socketItem.userId}"]`);
        this.attachSelfTourActions(row, { podium: this.rowUserOnPodium(tourStarted, socketItem) });
        return;
      }

      this.inviteToTourPeople.renderSingleItem({
        name: socketItem.userName,
        id: socketItem.userId,
        worldId: socketItem.worldId,
        userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
        icons: [
          { src: ICON.MESSAGE },
          { src: ICON.THREE_DOTS },
        ],
        currentSceneName: socketItem.currentSceneName,
        threeDotsContainer: ThreeDotsTourGuestsItems(),
        threeDotsCallback: (index, participant, event) => {
          this.onClickShowUserInfoTextAction(event, participant, socketItem);
          this.onClickInviteToPodiumTextAction(event, participant, socketItem);
          this.onClickRemoveFromTourTextAction(event, participant, socketItem);
        },
        customRender: (row) => {
          this.handleCustomRowActions(row, socketItem);
          row.find(".participant-name-and-scene-holder").remove();
          if (!this.model.iAmGuide()) {
            row.find('[data-lang="invite-to-podium-menu-text"]').remove();
            row.find('[data-lang="remove-from-tour-text"]').remove();
          }
          this.attachSelfTourActions(row, { podium: this.rowUserOnPodium(tourStarted, socketItem) });
        },
      });
    });

    this.inviteToTourPeople.renderParticipants();
  }

  pendingInvitationUpdate() {
    ///in rooms still not in tour
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted) {
      return;
    }

    const allUsers = this.model.socket.getUsers();
    const tourUsers = new Set(tourStarted.users || []);
    const podiumUsers = new Set(tourStarted.podiumUsers || []);
    const streamUsers = new Set(Object.keys(tourStarted.streams || {}));
    // People invited to the tour or the podium stay here until they join, so the invite state can show.
    const availableUsers = allUsers.filter(user =>
      !tourUsers.has(user.socketId) &&
      !podiumUsers.has(user.socketId) &&
      !streamUsers.has(user.socketId)
    );

    this.pendingInvitationPeople.itemIds.forEach((userId) => {
      if (!availableUsers.some(user => user.userId === userId)) {
        this.pendingInvitationPeople.removeItem(userId);
      }
    });

    availableUsers.forEach((socketItem) => {
      if (this.pendingInvitationPeople.itemIds.has(socketItem.userId)) {
        this.pendingInvitationPeople.ensureDragHandle({ id: socketItem.userId });
        return;
      }

      this.pendingInvitationPeople.renderSingleItem({
        name: socketItem.userName,
        id: socketItem.userId,
        worldId: socketItem.worldId,
        userAvatarUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
        icons: [
          { src: ICON.MESSAGE },
          { src: ICON.THREE_DOTS },
        ],
        userActivity: true,
        onActivityClick: (state, event) => {
          this.model.info('info', $trans('error-not-available-intour-mode'));
          return;
        },
        currentSceneName: socketItem.currentSceneName,
        threeDotsContainer: ThreeDotsInviteTourItems(socketItem),
        threeDotsCallback: (index, participant, event) => {
          this.onClickJumpToSceneAction(event, participant);
          this.onClickInviteToSceneTextAction(event, participant);
          this.onClickShowUserInfoTextAction(event, participant, socketItem);
          this.onClickInviteAsTourGuestTextAction(event, participant, socketItem);
          this.onClickInviteToPodiumTextAction(event, participant, socketItem);
          this.onClickResendInvitationTextAction(
            event,
            participant,
            socketItem
          );
        },
        customRender: (row) => {
          this.handleCustomRowActions(row, socketItem);
          row.find(".participant-name-and-scene-holder").remove();
          row.find('[data-lang="invite-to-tour-text"]').remove();
          if (this.model.isOneToOneTour(this.model.iAmInTour())) {
            row.find('[data-lang="invite-as-tour-guest-text"]').remove();
          }
          if (!this.model.iAmGuide()) {
            row.find('[data-lang="invite-as-tour-guest-text"]').remove();
            row.find('[data-lang="invite-to-podium-menu-text"]').remove();
          }
        },
      });
    });

    this.pendingInvitationPeople.renderParticipants();
  }

  onClickIconPersonAction(event, participant) {
    if (
      $(event.currentTarget).find('svg').hasClass("icon-person") ||
      $(event.currentTarget).find('svg').hasClass("icon-person-with-star")
    ) {
      if (participant.id === this.currentUserId) {
        $("#editProfile").trigger("click");
      } else {
        const socketItem = this.model.socket.getUsersObject()[participant.id];
        this.model.showUserInfo({
          data: null,
          userId: participant.id,
          eventOrigin: "nepoznatiFleg",
          socketItem,
        });
      }
    }
  }

  async onClickIconMessageAction(event, participant) {
    if (!$(event.currentTarget).find('svg').hasClass("icon-message")) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.ONE_TO_ONE_CHAT)) {
      return;
    }
    const user = this.model.socket.getUsersObject()[participant.id];
    this.model.createAndOpenChat(user);
    this.close();
  }

  async onClickActivityClick(state, event, participant) {
    const socketItem = this.model.socket.getUsersObject()[participant.userId];
    if (state === "settings") {
      $("#mediaSettings").trigger("click");
      this.close();
    }
    if (state === "meeting") {
      if (this.model.socket.getOccupiedSeatsAsArray().includes(socketItem.userId)) {
        this.model.info('info', `${socketItem.userName} is in a meeting`);
      }
    }
    if (state === "tour") {
      this.model.info('info', `${socketItem.userName} is in a tour`);
    }
    if (state === "none") {
      this.model.info('info', `${socketItem.userName} is not active`);
    }
    if (state === "chess" || state === "chess-red" || state === "chess-blue") {
      if (this.model.iAmInTour()) {
        this.model.info('info', $trans('error-chess-game-not-available-in-tour'));
        return;
      }
      if (state === "chess-red") {
        this.model.info('info', $trans('chess-game-locked'));
        return;
      }
      if (participant.id === this.currentUserId) {
        return;
      }
      else {
        const chessGame = this.model.isUserPlayingChess(participant.userId) || this.model.isUserVisitorInChessGame(participant.userId) || this.model.isUserInChessRoom(participant.userId);
        const mySceneId = this.model.socket.getUsersObject()[this.model.config.userId].currentSceneId;
        const goToChessGame = () => {
          if (socketItem.currentSceneId === mySceneId && chessGame) {
            this.model.openChessModal(chessGame, participant.userId);
            this.close();
          }
          else {
            this.close();
            this.model.dispatchEvent({
              type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
                sceneId: socketItem.currentSceneId,
                onComplete: () => {
                  this.model.openChessModal(chessGame, participant.userId);
                }
              }
            });
          }
        }

        if (this.model.view.iSitOnChair() || this.model.view.iSitOnScreenStream()) {
          this.model.confirm($trans('enter-chess-but-you-are-sitting'), () => {
            this.model.view.leaveSeatNoPrompt();
            if (this.model.view.iSitOnScreenStream()) {
              this.model.view.forceStopScreenShare();
            }
            this.model.view.viewrender3DWorld = true;
            this.model.view.customRenderMode = false;
            this.model.chessGameMode = true;
            this.model.hideLoading();
            $('#world-button-nav__default').hide();
            goToChessGame();
          });
        } else {
          goToChessGame();
        }
      }
    }
  }

  async onClickJumpToSceneAction(event, participant) {
    if (!$(event.currentTarget).is('[data-lang="jump-to-scene-text"]')) {
      return;
    }
    if ($(event.currentTarget).hasClass("disabled")) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_JUMP_TO_USER)) {
      return;
    }
    const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
    const security = this.model.config.security;
    if (user?.currentSceneId !== 'EDITOR') {
      if (user?.worldId !== this.model.config.worldId.toString()) {
        const callback = () => {
          window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${user.worldId}&security=${security}&loc=${user.currentSceneId}`;
        }
        this.close();
        this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback() } } })
      }
      else {
        if (user?.currentSceneId === this.model.socket.getUsersObject()[this.model.config.userId]?.currentSceneId) {
          this.model.info('info', $trans('error-cannot-jump-to-your-own-scene'));
          this.close();
          return;
        }
        this.model.dispatchEvent({
          type: SCENE_INTERACTION.JUMP_TO_SCENE,
          data: {
            sceneId: user?.currentSceneId,
          },
        });
      }
    }
    this.close();
  }

  async onClickInviteToSceneTextAction(event, participant) {
    if (!$(event.currentTarget).is('[data-lang="invite-to-scene-text"]')) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_JUMP_TO_USER)) {
      return;
    }
    const user = this.model.socket.getAllOnlineUsersObject()[participant.id];
    if (user?.worldId !== this.model.config.worldId.toString()) {
      if (user?.currentSceneId !== 'EDITOR') {
        this.model.socket.sendGlobalInvite(participant.id);
      }
    }
    else {
      if (user?.currentSceneId !== 'EDITOR') {
        if (user?.currentSceneId === this.model.socket.getUsersObject()[this.model.config.userId]?.currentSceneId) {
          this.model.info('info', $trans('error-cannot-jump-to-your-own-scene'));
          this.close();
          return;
        }
        this.model.inviteUserToRoom(user);
      }
    }
    this.close();
  }

  onClickShowUserInfoTextAction(event, participant, socketItem) {
    const isFromDropDown = $(event.currentTarget).is('[data-lang="show-user-info-text"]');
    const isFromAvatarImage = $(event.currentTarget).is("div .participant-avatar");
    if (!isFromDropDown && !isFromAvatarImage) {
      return;
    }
    this.close();
    this.model.showUserInfo({
      data: null,
      userId: participant.id,
      eventOrigin: "nepoznatiFleg",
      socketItem,
    });
  }

  onClickStartOneOnOneTourAction(event, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="start-one-on-one-tour-text"]')) {
      return;
    }
    if ($(event.currentTarget).hasClass("disabled")) {
      return;
    }
    this.close();
    const user = socketItem?.socketId
      ? socketItem
      : this.model.socket.getUsersObject()?.[socketItem?.userId || socketItem?.id];
    this.model.startOneOnOneTourWith(user || socketItem);
  }

  async onClickVideoCallTextAction(event, participant) {
    if (!$(event.currentTarget).is('[data-lang="video-call-text"]')) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.VIDEO_CALLS)) {
      return;
    }
    if (this.model.chessGameMode) {
      this.model.confirm($trans('exit-chess-game'), () => {
        this.model.forceQuitChessGame();
        this.close();
        this.model.startOneOnOneVideoCall(participant.id);
      })
    } else {
      this.close();
      this.model.startOneOnOneVideoCall(participant.id);
    }
  }

  async onClickChatTextAction(event, participant) {
    if (!$(event.currentTarget).is('[data-lang="chat-text"]')) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.ONE_TO_ONE_CHAT)) {
      return;
    }
    this.close();
    const user = this.model.socket.getUsersObject()[participant.id];
    this.model.createAndOpenChat(user);
  }
  async onClickPlayChessTextAction(event, participant, userActivityInstance) {
    if (!$(event.currentTarget).is('[data-lang="invite-to-chess-game-text"]')) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.CHESS_GAME)) {
      return;
    }
    if (participant.isGuest) {
      this.model.alert("error", $trans('error-requested-user-action'));
      return;
    }
    if (userActivityInstance.state.activeState !== "none") {
      this.model.alert("error", $trans('user-in-activity-error-text'));
      this.model.confirm($trans('user-in-activity-error-text'), () => {
        const user = this.model.socket.getUsersObject()[participant.id];
        this.model.createAndOpenChat(user);
        this.close();
      }, { header: true, title: $trans('send-as-message-text'), message: $trans('user-in-activity-error-text-message'), confirmBtnTxt: $trans('send-text'), cancelBtnTxt: $trans('cancel-text') });
      return;
    }
    this.close();
    const user = this.model.socket.getUsersObject()[participant.id];
    const isPlayingChess = this.model.isUserPlayingChess(this.model.config.userId);
    if (isPlayingChess) {
      this.model.socket.inviteToChessGame(user.userId, isPlayingChess.gameId);
      this.model.info("success", `${user.userName} ${$trans('chess-game-invitation-sent-text')}`);
    }
  }

  onClickInviteToTourTextAction(event, participant, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="invite-to-tour-text"]')) {
      return;
    }
    const tourStarted = tourExists(tourID, this.model.tourData);
    if (!tourStarted || !this.model.iAmGuide()) {
      return;
    }
    this.model.inviteUserToTour(socketItem);
  }

  onClickInviteAsTourGuestTextAction(event, participant, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="invite-as-tour-guest-text"]')) {
      return;
    }
    if (!this.model.iAmGuide()) {
      return;
    }
    this.model.inviteUserToTour(socketItem);
  }

  onClickRemoveFromPodiumTextAction(event, participant, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="remove-from-podium-text"]')) {
      return;
    }
    if (!this.model.iAmGuide()) {
      return;
    }
    this.model.removeUserFromPodium(socketItem);
  }

  onClickRemoveFromTourTextAction(event, participant, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="remove-from-tour-text"]')) {
      return;
    }
    if (!this.model.iAmGuide()) {
      return;
    }
    this.model.removeUserFromTour(socketItem);
  }

  onClickInviteToPodiumTextAction(event, participant, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="invite-to-podium-menu-text"]')) {
      return;
    }
    if (!this.model.iAmGuide()) {
      return;
    }
    this.model.inviteUserToPodium(socketItem);
  }

  onClickResendInvitationTextAction(event, participant, socketItem) {
    if (!$(event.currentTarget).is('[data-lang="resend-invitation-text"]')) {
      return;
    }
    const tourStarted = tourExists(tourID, this.model.tourData);
    if (!tourStarted || !this.model.iAmGuide()) {
      return;
    }
    this.model.inviteUserToTour(socketItem);
  }

  onClickRemoveFriendTextAction(event, participant) {
    if (!$(event.currentTarget).is('[data-lang="remove-from-friends-text"]')) {
      return;
    }
    this.model.worldFetcher.removeFriend(participant.id, (response) => {
      this.model.info("success", `Removed from friends list`);
      this.model.onFriendAddedSuccess(response);
      this.handleFriendRemovedItem(
        $(event.currentTarget).closest(".participants-list"),
        participant
      );
      this.onFriendRemoved(participant);
    });
  }

  async onClickAddFriendTextAction(event, participant) {
    if (!$(event.currentTarget).is('[data-lang="add-as-friend-text"]')) {
      return;
    }
    if (!await this.model.validatePlanFeature(FEATURE_NAMES.BUDDY_LIST)) {
      return;
    }
    this.model.worldFetcher.addAsFriend(participant.id, (response) => {
      this.model.onFriendAddedSuccess(response);
      this.handleFriendAddedItem(
        $(event.currentTarget).closest(".participants-list"),
        participant
      );
      this.onFriendAdded(participant);
    });
  }

  onFriendRemoved(participant) {
    this.handleFriendRemovedItem(this.sceneContainer, participant);
    this.handleFriendRemovedItem(this.roomContainer, participant);
    this.handleFriendRemovedItem(this.tourContainer, participant);
    this.handleFriendRemovedItem(this.inviteTourContainer, participant);
    this.handleFriendRemovedItem(this.pendingInvitationContainer, participant);
    this.friendsPeople.removeItem(participant.id);
  }

  handleFriendRemovedItem(container, participant) {
    const item = container.find(`[data-participant-id="${participant.id}"]`);
    item.find('[data-lang="add-as-friend-text"]').show();
    item.find('[data-lang="remove-from-friends-text"]').hide();
    item.find(".icon-person").parent().show();
    item.find(".icon-person-with-star").parent().hide();
  }

  onFriendAdded(participant) {
    this.handleFriendAddedItem(this.sceneContainer, participant);
    this.handleFriendAddedItem(this.roomContainer, participant);
    this.handleFriendAddedItem(this.tourContainer, participant);
    this.handleFriendAddedItem(this.inviteTourContainer, participant);
    this.handleFriendAddedItem(this.pendingInvitationContainer, participant);
  }

  handleFriendAddedItem(container, participant) {
    const item = container.find(`[data-participant-id="${participant.id}"]`);
    item.find('[data-lang="add-as-friend-text"]').hide();
    item.find('[data-lang="remove-from-friends-text"]').show();
    item.find(".icon-person").parent().hide();
    item.find(".icon-person-with-star").parent().show();
  }

  handleCustomRowActions(row, socketItem) {
    row.find(".icon-config").parent().hide();
    if (this.model.isFriend(socketItem.userId)) {
      row.find(".icon-person").parent().hide();
      row.find('[data-lang="add-as-friend-text"]').hide();
      row.find(".participant-avatar-star").show();
    } else {
      row.find('[data-lang="remove-from-friends-text"]').hide();
      row.find(".icon-person-with-star").parent().hide();
      row.find(".participant-avatar-star").hide();
    }
    if (this.model.config.isGuest) {
      // row.find(".icon-person").parent().addClass("disabled");
      row.find(".icon-message").parent().addClass("disabled");
      row.find('[data-lang="add-as-friend-text"]').hide();
      row.find('[data-lang="video-call-text"]').hide();
      row.find('[data-lang="remove-from-friends-text"]').hide();
      row.find(".icon-person-with-star").parent().hide();
    }
    if (socketItem.isGuest) {
      row.find('[data-lang="add-as-friend-text"]').hide();
      row.find('[data-lang="remove-from-friends-text"]').hide();
      row.find(".icon-person-with-star").parent().hide();
    }
    if (socketItem.userId === this.model.config.userId) {
      row.find(".icon-person").parent().hide();
      row.find(".icon-person-with-star").parent().hide();
      row.find(".icon-message").parent().hide();
      row.find(".icon-three-dots").parent().hide();
      row.find(".icon-config").parent().show();
    }
  }

  setPeopleIconCount(value) {
    this.peopleIcon.find(".world-bottom-nav__area__people__count").text(value);
  }
  updatePeopleIconCount() {
    const iconItems = this.model.socket.getUsers();
    this.setPeopleIconCount(iconItems.length);
  }
  updateUI(userid) {
    ///find all inside scenePeople, participant-row(s) with data-participant-id equal to uswerId
    const user = this.model.socket.getUsersObject()[userid];
    if (user) {
      let items = this.scenePeople.container.find(`[data-participant-id="${userid}"]`);
      if (items) {
        items.find(".participant-avatar img").attr("src", user.userAvatarUrl);
        items.find(".participant-name").text(user.userName);
      }
      items = this.roomPeople.container.find(`[data-participant-id="${userid}"]`);
      if (items) {
        items.find(".participant-avatar img").attr("src", user.userAvatarUrl);
        items.find(".participant-name").text(user.userName);
      }
      items = this.tourPeople && this.tourPeople.container.find(`[data-participant-id="${userid}"]`);
      if (items) {
        items.find(".participant-avatar img").attr("src", user.userAvatarUrl);
        items.find(".participant-name").text(user.userName);
      }
      items = this.friendsPeople && this.friendsPeople.container.find(`[data-participant-id="${userid}"]`);
      if (items) {
        items.find(".participant-avatar img").attr("src", user.userAvatarUrl);
        items.find(".participant-name").text(user.userName);
        items.find(".participant-avatar-mood").removeClass("mood-1 mood-2 mood-3").addClass(`mood-${user.currentUserMood}`);
      }
    }
  }
  updateUIAfterFriendsSet() {
    if (this.model.config.isGuest || !this.model.friends) {
      return;
    }
    const { online } = this.model.friends;
    online.forEach((user) => {
      this.roomPeople.updateRowIcon(user.userId);
      this.scenePeople.updateRowIcon(user.userId);
    });
  }
  updateSceneNamesInLists() {
    this.roomPeople.container.find("[data-participant-id]").each((index, item) => {
      const user = this.model.socket.getUsersObject()[$(item).data("participant-id")];
      if (user) {
        $(item).find(".participant-scene-name").text(`${this.model.sceneData.name}-${user.currentSceneName}`);
      }
    });
    this?.friendsPeople?.container.find("[data-participant-id]").each((index, item) => {
      const user = this.model.socket.getAllOnlineUsersObject()[$(item).data("participant-id")];
      if (user) {
        $(item).find(".participant-scene-name").text(`${user.worldName}-${user.currentSceneName}`);
      }
    });
  }

  isFriendLocationJumpBlocked(userId) {
    if (this.model.iAmInTour()) {
      return true;
    }
    if (this.model.isUserInTour(userId)) {
      return true;
    }
    const onlineFriend = this.model.friends?.online?.find(
      (user) => String(user.userId) === String(userId)
    );
    return !!(onlineFriend && onlineFriend.tourName);
  }

  setFriendLocationJumpEnabled(row, enabled) {
    row.find("svg.go-to-space").closest(".icon-wrapper")
      .toggleClass("disabled", !enabled)
      .attr("aria-disabled", enabled ? null : "true");
    row.find('[data-lang="jump-to-scene-text"]')
      .toggleClass("disabled", !enabled)
      .attr("aria-disabled", enabled ? null : "true");
    row.find(".participant-scene-name").toggleClass("is-jump-disabled", !enabled);
  }

  updateFriendLocationJump(userId) {
    if (!this.friendsPeople) {
      return;
    }
    const row = this.friendsPeople.participantsList.find(`[data-participant-id="${userId}"]`);
    if (!row.length) {
      return;
    }
    this.setFriendLocationJumpEnabled(row, !this.isFriendLocationJumpBlocked(userId));
  }

  updateUserActivity() {
    if (!this.scenePeople || !this.roomPeople || !this.pendingInvitationPeople) {
      return;
    }
    const occupiedSeats = typeof this.model.socket.getOccupiedSeatsAsArray === 'function'
      ? this.model.socket.getOccupiedSeatsAsArray()
      : [];
    const setStateIfExists = (list, id, state) => {
      if (list && list.userActivityInstances && list.userActivityInstances.has(id)) {
        const instance = list.userActivityInstances.get(id);
        instance && instance.setActiveState(state);
      }
    };
    const allIds = new Set([
      ...this.scenePeople.userActivityInstances.keys(),
      ...this.roomPeople.userActivityInstances.keys(),
      ...this.pendingInvitationPeople.userActivityInstances.keys(),
    ]);
    allIds.forEach((id) => {
      setStateIfExists(this.scenePeople, id, "none");
      setStateIfExists(this.roomPeople, id, "none");
      setStateIfExists(this.pendingInvitationPeople, id, "none");
      setStateIfExists(this.friendsPeople, id, "none")
      if (occupiedSeats.includes(id)) {
        setStateIfExists(this.scenePeople, id, "meeting");
        setStateIfExists(this.roomPeople, id, "meeting");
        setStateIfExists(this.pendingInvitationPeople, id, "meeting");
        setStateIfExists(this.friendsPeople, id, "meeting");
      }
      if (this.model.isUserInTour(id)) {
        setStateIfExists(this.scenePeople, id, "tour");
        setStateIfExists(this.roomPeople, id, "tour");
        setStateIfExists(this.pendingInvitationPeople, id, "tour");
        setStateIfExists(this.friendsPeople, id, "tour");
      }
      if (this.model.isUserInChessRoom(id)) {
        setStateIfExists(this.scenePeople, id, "chess");
        setStateIfExists(this.roomPeople, id, "chess");
        setStateIfExists(this.pendingInvitationPeople, id, "chess");
        setStateIfExists(this.friendsPeople, id, "chess");
      }
      if (this.model.isUserPlayingChess(id)) {
        setStateIfExists(this.scenePeople, id, "chess");
        setStateIfExists(this.roomPeople, id, "chess");
        setStateIfExists(this.pendingInvitationPeople, id, "chess");
        setStateIfExists(this.friendsPeople, id, "chess");
      }
      const userPlaysChess = this.model.isUserVisitorInChessGame(id) || this.model.isUserPlayingChess(id);
      if (userPlaysChess) {
        const { chessGame } = userPlaysChess;
        setStateIfExists(this.scenePeople, id, "chess");
        setStateIfExists(this.roomPeople, id, "chess");
        setStateIfExists(this.pendingInvitationPeople, id, "chess");
        setStateIfExists(this.friendsPeople, id, "chess");
        if (chessGame.takenSeats.player1 && chessGame.takenSeats.player2) {
          setStateIfExists(this.scenePeople, id, "chess-blue");
          setStateIfExists(this.roomPeople, id, "chess-blue");
          setStateIfExists(this.pendingInvitationPeople, id, "chess-blue");
          setStateIfExists(this.friendsPeople, id, "chess-blue");
        }
        if (chessGame.gameData.isLocked) {
          setStateIfExists(this.scenePeople, id, "chess-red");
          setStateIfExists(this.roomPeople, id, "chess-red");
          setStateIfExists(this.pendingInvitationPeople, id, "chess-red");
          setStateIfExists(this.friendsPeople, id, "chess-red");
        }
      }
    });
    if (this.friendsPeople) {
      this.friendsPeople.itemIds.forEach((userId) => this.updateFriendLocationJump(userId));
    }
  }
  updateInvitedPeople() {
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted) {
      return;
    }
    const allUsers = this.model.socket.getUsers();
    allUsers.forEach((user) => {
      let item = this.inviteTourContainer.find(`[data-participant-id="${user.userId}"]`).not(".participant-row--ghost");
      if (item.length && !this.invitationGhostKind(user.userId)) {
        item.find(".participant-name").text(user.userName);
      }
      item = this.pendingInvitationContainer.find(`[data-participant-id="${user.userId}"]`).not(".participant-row--ghost");
      if (item.length && !this.invitationGhostKind(user.userId)) {
        item.find(".participant-name").text(user.userName);
      }
    });
  }
}
